import { useState, useEffect } from 'react';
import { supabase } from '../../../lib/supabase';
import { uploadToCloudinary, toThumbnail } from '../../../lib/cloudinary';

const CATEGORIES = ['Food', 'Drink', 'Snack', 'Dessert', 'Other'];
const emptyForm = { code: '', name: '', category: 'Food', base_price: '', emoji: '🍘', swatch: '#FEF9C3', has_ice: false, has_sugar: false, prod_mode: 'individual', ind_mins: 5, batch_qty: 10, batch_mins: 30, hpp: '', is_hidden: false, image_url: '', is_featured: false, featured_label: 'Favorit', featured_order: 0, is_hero: false };

function VariantEditor({ variants, onChange }) {
  const add = () => onChange([...variants, { name: '', extra_price: 0 }]);
  const remove = i => onChange(variants.filter((_, idx) => idx !== i));
  const update = (i, field, val) => onChange(variants.map((v, idx) => idx === i ? { ...v, [field]: val } : v));
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
        <label style={{ fontSize: '.74rem', color: 'var(--muted)' }}>Varian</label>
        <button type="button" onClick={add} style={{ fontSize: '.72rem', color: 'var(--gold)', background: 'none', border: 'none', cursor: 'pointer' }}>+ Tambah</button>
      </div>
      {variants.map((v, i) => (
        <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 6, alignItems: 'center' }}>
          <input placeholder="Nama varian (e.g. Pedas)" value={v.name} onChange={e => update(i, 'name', e.target.value)}
            style={{ flex: 2, border: '1.5px solid #DDD', borderRadius: 6, padding: '6px 10px', fontSize: '.82rem', outline: 'none' }} />
          <input type="number" placeholder="Harga tambah" value={v.extra_price} onChange={e => update(i, 'extra_price', +e.target.value)}
            style={{ flex: 1, border: '1.5px solid #DDD', borderRadius: 6, padding: '6px 10px', fontSize: '.82rem', outline: 'none' }} />
          <button type="button" onClick={() => remove(i)} style={{ color: '#C62828', background: 'none', border: 'none', cursor: 'pointer', fontSize: '1rem', lineHeight: 1 }}>×</button>
        </div>
      ))}
    </div>
  );
}

const Field = ({ label, children }) => (
  <div>
    <label style={{ display: 'block', fontSize: '.74rem', color: 'var(--muted)', marginBottom: 4 }}>{label}</label>
    {children}
  </div>
);

const inputStyle = { width: '100%', border: '1.5px solid #DDD', borderRadius: 8, padding: '8px 12px', fontSize: '.86rem', outline: 'none', boxSizing: 'border-box' };

export default function MenuPOS() {
  const [items, setItems]       = useState([]);
  const [form, setForm]         = useState(emptyForm);
  const [variants, setVariants] = useState([]);
  const [editId, setEditId]     = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [search, setSearch]     = useState('');
  const [catFilter, setCat]     = useState('Semua');
  const [uploading, setUploading] = useState(false);

  useEffect(() => { load(); }, []);

  async function load() {
    const { data } = await supabase.from('menu_items').select('*, menu_variants(name,extra_price,sort_order)').order('category').order('name');
    setItems(data || []);
  }

  async function handleSave() {
    if (!form.name || !form.base_price) return;
    const payload = { ...form, base_price: +form.base_price, hpp: +(form.hpp || 0), has_ice: !!form.has_ice, has_sugar: !!form.has_sugar, is_hidden: !!form.is_hidden, is_featured: !!form.is_featured, featured_label: (form.featured_label || 'Favorit').trim() || 'Favorit', featured_order: +form.featured_order || 0, is_hero: !!form.is_hero };
    let iid;
    if (editId) {
      await supabase.from('menu_items').update(payload).eq('id', editId);
      iid = editId;
    } else {
      const { data } = await supabase.from('menu_items').insert(payload).select('id').single();
      iid = data.id;
    }
    // Hanya boleh 1 menu jadi hero banner dalam satu waktu
    if (payload.is_hero) {
      await supabase.from('menu_items').update({ is_hero: false }).eq('is_hero', true).neq('id', iid);
    }
    await supabase.from('menu_variants').delete().eq('menu_item_id', iid);
    if (variants.length) {
      await supabase.from('menu_variants').insert(variants.filter(v => v.name).map((v, i) => ({ menu_item_id: iid, name: v.name, extra_price: +v.extra_price || 0, sort_order: i })));
    }
    reset(); load();
  }

  async function handleImageUpload(e) {
    const file = e.target.files[0]; if (!file) return;
    setUploading(true);
    try {
      const url = await uploadToCloudinary(file, 'sapan/menu-items');
      setForm(f => ({ ...f, image_url: url }));
    } catch { alert('Upload gagal, coba lagi.'); }
    setUploading(false);
  }

  async function handleDelete(id) {
    if (!window.confirm('Hapus menu item ini?')) return;
    await supabase.from('menu_items').delete().eq('id', id);
    load();
  }

  function handleEdit(item) {
    setForm({ code: item.code || '', name: item.name, category: item.category, base_price: item.base_price, emoji: item.emoji, swatch: item.swatch, has_ice: item.has_ice, has_sugar: item.has_sugar, prod_mode: item.prod_mode, ind_mins: item.ind_mins, batch_qty: item.batch_qty, batch_mins: item.batch_mins, hpp: item.hpp || '', is_hidden: item.is_hidden, image_url: item.image_url || '', is_featured: !!item.is_featured, featured_label: item.featured_label || 'Favorit', featured_order: item.featured_order ?? 0, is_hero: !!item.is_hero });
    setVariants((item.menu_variants || []).map(v => ({ name: v.name, extra_price: v.extra_price })));
    setEditId(item.id); setShowForm(true); window.scrollTo(0, 0);
  }

  function reset() { setForm(emptyForm); setVariants([]); setEditId(null); setShowForm(false); }

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const filtered = items.filter(i => {
    if (catFilter !== 'Semua' && i.category !== catFilter) return false;
    if (search && !i.name.toLowerCase().includes(search.toLowerCase()) && !i.code.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const cats = ['Semua', ...CATEGORIES];

  return (
    <div style={{ padding: 'clamp(16px,4vw,28px) clamp(12px,4vw,24px) 60px' }}>
      <style>{`@media(max-width:580px){.menu-form-grid{grid-template-columns:1fr!important}}`}</style>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
        <div>
          <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1.5rem' }}>Menu POS</div>
          <div style={{ fontSize: '.82rem', color: 'var(--muted)' }}>{items.length} item terdaftar</div>
        </div>
        <button onClick={() => { reset(); setShowForm(true); }} style={{ padding: '9px 18px', borderRadius: 8, background: '#CD5226', color: '#fff', border: 'none', fontSize: '.84rem', fontFamily: "'DM Sans',sans-serif", cursor: 'pointer' }}>
          + Tambah Menu
        </button>
      </div>

      {/* Form */}
      {showForm && (
        <div className="fade-up" style={{ background: 'white', borderRadius: 'var(--radius)', border: '1px solid var(--border)', padding: '22px', marginBottom: 20, boxShadow: 'var(--shadow)' }}>
          <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1.1rem', marginBottom: 18 }}>{editId ? 'Edit Menu' : 'Menu Baru'}</div>
          <div className="menu-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
            <Field label="Nama Menu *">
              <input value={form.name} onChange={e => set('name', e.target.value)} placeholder="e.g. Cireng Ayam Suwir" style={inputStyle} />
            </Field>
            <Field label="Kode">
              <input value={form.code} onChange={e => set('code', e.target.value)} placeholder="e.g. CRG-01" style={inputStyle} />
            </Field>
            <Field label="Kategori">
              <select value={form.category} onChange={e => set('category', e.target.value)} style={inputStyle}>
                {CATEGORIES.map(c => <option key={c}>{c}</option>)}
              </select>
            </Field>
            <Field label="Harga Jual (Rp) *">
              <input type="number" value={form.base_price} onChange={e => set('base_price', e.target.value)} placeholder="15000" style={inputStyle} />
            </Field>
            <Field label="HPP (Rp)">
              <input type="number" value={form.hpp} onChange={e => set('hpp', e.target.value)} placeholder="0" style={inputStyle} />
            </Field>
            <Field label="Emoji">
              <input value={form.emoji} onChange={e => set('emoji', e.target.value)} style={inputStyle} />
            </Field>
            <Field label="Warna Kartu">
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <input type="color" value={form.swatch} onChange={e => set('swatch', e.target.value)} style={{ width: 40, height: 36, border: '1.5px solid #DDD', borderRadius: 6, padding: 2, cursor: 'pointer' }} />
                <div style={{ width: 80, height: 36, borderRadius: 6, background: form.swatch, border: '1px solid #DDD' }} />
              </div>
            </Field>
            <Field label="Mode Produksi">
              <select value={form.prod_mode} onChange={e => set('prod_mode', e.target.value)} style={inputStyle}>
                <option value="individual">Individual</option>
                <option value="batch">Batch</option>
              </select>
            </Field>
            {form.prod_mode === 'individual'
              ? <Field label="Waktu Buat (menit)"><input type="number" value={form.ind_mins} onChange={e => set('ind_mins', +e.target.value)} style={inputStyle} /></Field>
              : <>
                  <Field label="Qty per Batch"><input type="number" value={form.batch_qty} onChange={e => set('batch_qty', +e.target.value)} style={inputStyle} /></Field>
                  <Field label="Waktu Batch (menit)"><input type="number" value={form.batch_mins} onChange={e => set('batch_mins', +e.target.value)} style={inputStyle} /></Field>
                </>
            }
          </div>
          <div style={{ display: 'flex', gap: 20, marginBottom: 14, flexWrap: 'wrap' }}>
            {[['has_ice', 'Ada Es'], ['has_sugar', 'Ada Gula'], ['is_hidden', 'Sembunyikan']].map(([k, l]) => (
              <label key={k} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '.82rem', cursor: 'pointer' }}>
                <input type="checkbox" checked={!!form[k]} onChange={e => set(k, e.target.checked)} />
                {l}
              </label>
            ))}
          </div>

          {/* Foto menu */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: '.74rem', color: 'var(--muted)', marginBottom: 6 }}>Foto Menu (opsional, dipakai kalau menu ditampilkan sebagai unggulan di beranda)</label>
            {form.image_url && (
              <img src={toThumbnail(form.image_url)} alt="" style={{ width: 64, height: 48, objectFit: 'cover', borderRadius: 6, border: '2px solid #DDD', marginBottom: 8, display: 'block' }} />
            )}
            <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 14px', borderRadius: 7, background: 'var(--cream)', border: '1.5px solid var(--border)', fontSize: '.78rem', cursor: 'pointer' }}>
              {form.image_url ? '🔄 Ganti Gambar' : '📷 Pilih Gambar'}
              <input type="file" accept="image/*" onChange={handleImageUpload} style={{ display: 'none' }} />
            </label>
            {uploading && <span style={{ fontSize: '.76rem', color: 'var(--muted)', marginLeft: 10 }}>Mengunggah…</span>}
          </div>

          {/* Tampil di beranda ("Dari Dapur Kami") — hanya berlaku saat tidak ada PO aktif */}
          <div style={{ marginBottom: 16, padding: 14, borderRadius: 10, background: 'var(--sand)', border: '1px solid var(--border)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: form.is_featured ? 10 : 0 }}>
              <input type="checkbox" id="menu-featured" checked={form.is_featured} onChange={e => set('is_featured', e.target.checked)} />
              <label htmlFor="menu-featured" style={{ fontSize: '.82rem', fontWeight: 600 }}>
                ⭐ Tampilkan di beranda (section "Dari Dapur Kami")
              </label>
            </div>
            {form.is_featured && (
              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 180px' }}>
                  <label style={{ display: 'block', fontSize: '.72rem', color: 'var(--muted)', marginBottom: 4 }}>Label badge</label>
                  <input value={form.featured_label} onChange={e => set('featured_label', e.target.value)} placeholder="Favorit" style={inputStyle} />
                </div>
                <div style={{ width: 100 }}>
                  <label style={{ display: 'block', fontSize: '.72rem', color: 'var(--muted)', marginBottom: 4 }}>Urutan</label>
                  <input type="number" value={form.featured_order} onChange={e => set('featured_order', e.target.value)} placeholder="0" style={inputStyle} />
                </div>
                <div style={{ fontSize: '.7rem', color: 'var(--muted)', flexBasis: '100%' }}>
                  Butuh foto menu agar tampil rapi di beranda. Section ini hanya muncul saat tidak ada PO yang sedang aktif.
                </div>
              </div>
            )}
          </div>
          {/* Hero banner beranda — prioritas tetap produk PO aktif kalau ada */}
          <div style={{ marginBottom: 16, padding: 14, borderRadius: 10, background: 'var(--sand)', border: '1px solid var(--border)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="checkbox" id="menu-hero" checked={form.is_hero} onChange={e => set('is_hero', e.target.checked)} />
              <label htmlFor="menu-hero" style={{ fontSize: '.82rem', fontWeight: 600 }}>
                🖼️ Tampilkan sebagai Hero Banner (gambar besar di atas beranda)
              </label>
            </div>
            <div style={{ fontSize: '.7rem', color: 'var(--muted)', marginTop: 6 }}>
              Hanya 1 menu yang bisa jadi hero banner — kalau diaktifkan di sini, menu lain otomatis dimatikan. Hero banner ini hanya muncul saat <b>tidak ada PO yang sedang aktif</b> (kalau ada PO aktif, gambar produk PO yang tampil). Butuh Foto Menu agar tampil rapi.
            </div>
          </div>

          <div style={{ marginBottom: 16 }}>
            <VariantEditor variants={variants} onChange={setVariants} />
          </div>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button onClick={reset} style={{ padding: '8px 16px', borderRadius: 8, background: 'var(--cream)', border: '1px solid var(--border)', fontSize: '.82rem', fontFamily: "'DM Sans',sans-serif", cursor: 'pointer', color: 'var(--muted)' }}>Batal</button>
            <button onClick={handleSave} style={{ padding: '8px 18px', borderRadius: 8, background: '#CD5226', color: '#fff', border: 'none', fontSize: '.82rem', fontFamily: "'DM Sans',sans-serif", cursor: 'pointer' }}>
              {editId ? 'Simpan Perubahan' : 'Tambah Menu'}
            </button>
          </div>
        </div>
      )}

      {/* Filter */}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 14, alignItems: 'center' }}>
        {cats.map(c => (
          <button key={c} onClick={() => setCat(c)} style={{ padding: '5px 12px', borderRadius: 20, border: '1px solid var(--border)', background: catFilter === c ? '#CD5226' : 'white', color: catFilter === c ? '#fff' : 'var(--muted)', fontSize: '.76rem', cursor: 'pointer' }}>{c}</button>
        ))}
        <input placeholder="Cari nama/kode..." value={search} onChange={e => setSearch(e.target.value)}
          style={{ marginLeft: 'auto', border: '1.5px solid #DDD', borderRadius: 8, padding: '5px 12px', fontSize: '.82rem', outline: 'none', minWidth: 150 }}
          onFocus={e => e.target.style.borderColor = 'var(--gold)'} onBlur={e => e.target.style.borderColor = '#DDD'} />
      </div>

      {/* List */}
      {filtered.map(item => (
        <div key={item.id} style={{ background: 'white', borderRadius: 'var(--radius)', border: '1px solid var(--border)', padding: '13px 16px', marginBottom: 8, display: 'flex', gap: 12, alignItems: 'center', boxShadow: 'var(--shadow)', opacity: item.is_hidden ? 0.55 : 1 }}>
          {item.image_url
            ? <img src={toThumbnail(item.image_url)} alt="" style={{ width: 44, height: 44, borderRadius: 8, objectFit: 'cover', flexShrink: 0 }} />
            : <div style={{ width: 44, height: 44, borderRadius: 8, background: item.swatch, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, flexShrink: 0 }}>{item.emoji}</div>
          }
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 500, fontSize: '.9rem' }}>{item.name} {item.is_hidden && <span style={{ fontSize: '.68rem', color: '#999', background: '#F5F5F5', borderRadius: 4, padding: '1px 5px' }}>hidden</span>}</div>
            <div style={{ fontSize: '.76rem', color: 'var(--muted)' }}>
              {item.category} · Rp {(item.base_price || 0).toLocaleString('id-ID')}
              {item.hpp > 0 && <span style={{ marginLeft: 6, color: '#1B5E20' }}>HPP Rp {item.hpp.toLocaleString('id-ID')}</span>}
              {item.menu_variants?.length > 0 && <span style={{ marginLeft: 6 }}>· {item.menu_variants.length} varian</span>}
              {item.is_featured && <span style={{ marginLeft: 6, color: 'var(--primary)' }}>· ⭐ {item.featured_label || 'Unggulan'}</span>}
              {item.is_hero && <span style={{ marginLeft: 6, color: '#1565C0' }}>· 🖼️ Hero Banner</span>}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
            <button onClick={() => handleEdit(item)} style={{ padding: '5px 12px', borderRadius: 6, background: 'var(--cream)', border: '1px solid var(--border)', fontSize: '.74rem', cursor: 'pointer' }}>Edit</button>
            <button onClick={() => handleDelete(item.id)} style={{ padding: '5px 12px', borderRadius: 6, background: '#FFEBEE', border: '1px solid #FFCDD2', color: '#C62828', fontSize: '.74rem', cursor: 'pointer' }}>Hapus</button>
          </div>
        </div>
      ))}
      {filtered.length === 0 && <div style={{ textAlign: 'center', padding: 32, color: 'var(--muted)', fontSize: '.84rem' }}>Tidak ada item ditemukan</div>}
    </div>
  );
}
